import React, { Fragment } from 'react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack5';
import { AutoSizer, List } from 'react-virtualized';
import { usePdfSettings } from 'components/newAccountSteps/initialStep/documentation/documentsModal/hooks/usePdfSettings';

export const ScrollableDocument = ({ documentIndex, pdfContainerRef, file, onScrollChange }) => {
    const {
        pdfSettings: { numPages, pageHeight, scale },
        handleDocumentResize,
        handleDocumentLoadSuccess,
    } = usePdfSettings();

    const handleScroll = ({ clientHeight, scrollHeight, scrollTop }) => {
        onScrollChange({
            documentIndex,
            hasScrolledToBottom: scrollTop + clientHeight >= scrollHeight - 5,
            hasScrolledOutsideOfDocumentActions: scrollTop + clientHeight < scrollHeight - 100,
        });
    };

    const rowRenderer = ({ key, index, style }) => (
        <span key={key} style={style}>
            <Page
                scale={scale}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                loading=""
                pageNumber={index + 1}
            />
        </span>
    );

    return (
        <AutoSizer onResize={handleDocumentResize}>
            {({ height, width }) => (
                <Fragment>
                    {!!width && width > 0 && (
                        <Fragment>
                            <div ref={pdfContainerRef}>
                                <Document file={file || ''} loading="" onLoadSuccess={handleDocumentLoadSuccess(width)}>
                                    {numPages && (
                                        <List
                                            height={height}
                                            rowCount={numPages}
                                            rowHeight={pageHeight}
                                            rowRenderer={rowRenderer}
                                            width={width}
                                            overscanRowCount={1}
                                            onScroll={handleScroll}
                                        />
                                    )}
                                </Document>
                            </div>
                        </Fragment>
                    )}
                </Fragment>
            )}
        </AutoSizer>
    );
};
